/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Empty_TitleInputs */

const en_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No applications yet`)
};

const de_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Bewerbungen`)
};

const fr_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune candidature pour le moment`)
};

const es_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay solicitudes`)
};

const it_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna candidatura ancora`)
};

const nl_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen sollicitaties`)
};

const pl_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak aplikacji`)
};

const fi_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä hakemuksia`)
};

const da_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen ansøgninger endnu`)
};

const sv_applications_empty_title = /** @type {(inputs: Applications_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga ansökningar ännu`)
};

/**
* | output |
* | --- |
* | "No applications yet" |
*
* @param {Applications_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_empty_title = /** @type {((inputs?: Applications_Empty_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Empty_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_empty_title(inputs)
	if (locale === "fr") return fr_applications_empty_title(inputs)
	if (locale === "es") return es_applications_empty_title(inputs)
	if (locale === "it") return it_applications_empty_title(inputs)
	if (locale === "nl") return nl_applications_empty_title(inputs)
	if (locale === "pl") return pl_applications_empty_title(inputs)
	if (locale === "fi") return fi_applications_empty_title(inputs)
	if (locale === "da") return da_applications_empty_title(inputs)
	if (locale === "sv") return sv_applications_empty_title(inputs)
	return en_applications_empty_title(inputs)
});